module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/administrators/administrator-list/administrator-list.component.scss
// module id = ./libs/atenea-cms/src/administrators/administrator-list/administrator-list.component.scss
// module chunks = main